import { PaymentProviderType } from "@/types/graphql/site.generated";

export interface CheckoutLayoutProvider {
  name: string;
  clientId?: string | null;
}

export interface CheckoutLayout {
  hasPaypalProvider: boolean;
  /** PayPal единственный способ: платёж под основного провайдера не
   * заводится, кнопка PayPal занимает место формы (спека §6). */
  skipPrimaryAttempt: boolean;
  /** Основной способ уводит на свою страницу (Paynet): вместо немедленного
   * редиректа кнопка «Оплатить картой», под ней «или» и PayPal. */
  primaryByButton: boolean;
  /** Кнопка PayPal реально нарисуется (есть PAYPAL с clientId). */
  paypalVisible: boolean;
}

/** Раскладка диалога оплаты по способам цены (providers в порядке бэкенда,
 * первый не-PayPal это основная форма). */
export function checkoutLayout(
  providers: readonly CheckoutLayoutProvider[],
): CheckoutLayout {
  const primary = providers.find(
    (p) => p.name !== PaymentProviderType.PaypalType,
  )?.name;
  const hasPaypalProvider = providers.some(
    (p) => p.name === PaymentProviderType.PaypalType,
  );
  return {
    hasPaypalProvider,
    skipPrimaryAttempt: !primary && hasPaypalProvider,
    primaryByButton: primary === PaymentProviderType.PaynetType,
    paypalVisible: providers.some(
      (p) => p.name === PaymentProviderType.PaypalType && !!p.clientId,
    ),
  };
}
